import logo from '../assets/EncoreLogo.svg'
import mark from '../assets/EncoreE.svg'

/**
 * The wordmark, tinted by `currentColor`.
 *
 * The source SVG carries solid black paths — it's drawn to be used as a
 * template, the way `renderingMode(.template)` uses it on the native side. An
 * `<img>` can't be recoloured, so it's applied as a mask over the current text
 * colour instead. That keeps one asset working in both skins rather than
 * shipping a light and a dark copy that drift apart.
 */
export default function Wordmark({
  height = 22,
  compact = false,
  title = 'Encore',
}: {
  height?: number
  compact?: boolean
  title?: string
}) {
  const source = compact ? mark : logo
  // 808.794 × 145.959 for the wordmark; the E is square.
  const ratio = compact ? 1 : 808.794 / 145.959

  return (
    <span
      role="img"
      aria-label={title}
      style={{
        display: 'block',
        width: height * ratio,
        height,
        background: 'currentColor',
        maskImage: `url(${source})`,
        WebkitMaskImage: `url(${source})`,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
      }}
    />
  )
}
